export const DEFAULT_DONUT_SIZE = 48
export const DEFAULT_STROKE_WIDTH = 4
